import React, {ChangeEventHandler} from 'react';
import {FormGroup, Label, Input, FormFeedback} from 'reactstrap';

interface propiedades {
  label: string;
  value?: string;
  evento: ChangeEventHandler<HTMLInputElement>;
  error?: string;
  id: string;
}

const FormTextInput = (prop: propiedades) => {
  const {label, value, evento, error, id} = prop;
  return (
    <FormGroup>
      <Label for={id}>{label}:</Label>
      <Input
        type="text"
        name={id}
        id={id}
        value={value}
        onChange={evento}
        className={error ? 'is-invalid' : ''}
      />
      {error && <FormFeedback>{error}</FormFeedback>}
    </FormGroup>
  );
};

export default FormTextInput;
